import OdinIcon from '../odin-icon/odin-icon.component';

const ContinuousScrollerDataLoadingIndicator = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center overflow-hidden pt-1">
      <OdinIcon icon="Loader" className="size-5 animate-spin" />
    </div>
  );
};

export default ContinuousScrollerDataLoadingIndicator;
